'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBox = function IoIosBox(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.8 31.3v-15h22.5v15h-22.5z m8.7-12.5c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.3 1.2 1.3h5c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2h-5z m-10-10h25v6.2h-25v-6.2z' })
        )
    );
};

exports.default = IoIosBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-box.js
// module id = 2092
// module chunks = 0